const video = document.querySelector("#v_glass_container_video__video");
if (video) {
  const overlay = document.querySelector(".v_glass_container_video__overlay");

  overlay?.addEventListener("click", () => {
    video.play();
    video.controls = true;
    overlay.style.display = "none";
  });

  // Min height for Service section - FIX ERROR IPHONE

  const section = document.querySelector(".v_service");
  const glassContainer = document.querySelector(".v_glass_container__wrapper_blur");
  const videoContainer = document.querySelector(".v_glass_container_video__wrapper");
  let sumHeight = parseInt(window.getComputedStyle(glassContainer).height) + parseInt(window.getComputedStyle(videoContainer).height);
  const sectionContainer = document.querySelector(".v_service__container");
  let paddingSectionContainer = parseInt(window.getComputedStyle(sectionContainer).paddingTop) + parseInt(window.getComputedStyle(sectionContainer).paddingBottom);
  section.style.minHeight = `${sumHeight + paddingSectionContainer}px`;
}
